import { Tenant, UpdateTenant, Application, Cluster } from '../types';

export const deserializeApplication = (json: any): Application => {
  const { application_id, ...rest } = json;
  return { id: application_id, ...rest } as Application;
};

export const deserializeTenant = (json: any): Tenant => {
  const instance = new Tenant({
    ownerObjectId: json.owner_object_id.toLocaleLowerCase(),
  });
  instance.id = json.id;
  instance.stage = json.stage;
  instance.name = json.name;
  instance.applicationId = json.application_id;
  if (json.application)
    instance.application = deserializeApplication(json.application);
  instance.securityObjectIds = json.security_object_ids;
  instance.pimEnabled = json.pim_enabled;
  instance.pimGroupId = json.pim_group_id;
  instance.slackChannel = json.slack_channel;
  instance.tier = json.tier;
  instance.clusterId = json.cluster_id;
  instance.nodeGroups = json.node_groups;
  instance.namespaceQuota = json.namespace_quota;
  instance.resourceQuota = {
    cpuLimit: json.resource_quota.cpu_limit,
    cpuRequest: json.resource_quota.cpu_request,
    memoryLimit: json.resource_quota.memory_limit,
    memoryRequest: json.resource_quota.memory_request,
  };

  if (json.argocd_project)
    instance.argocdProject = {
      repositories: json.argocd_project.repositories,
      rootPath: json.argocd_project.root_path,
      helmRepositories: json.argocd_project.helm_repositories,
    };

  instance.argoUrl = json.argocd_url;
  instance.kubeConfig = json.kubeconfig;

  return instance;
};

export const serializeTenant = (obj: Tenant | UpdateTenant): any => {
  const json: any = {};

  json.name = obj.name;
  if ('ownerObjectId' in obj && obj.ownerObjectId)
    json.owner_object_id = obj.ownerObjectId.toLocaleLowerCase();
  if (obj.applicationId) json.application_id = obj.applicationId;
  json.security_object_ids = obj.securityObjectIds;
  json.pim_enabled = obj.pimEnabled;
  json.slack_channel = obj.slackChannel;
  json.cluster_id = obj.clusterId;
  json.node_groups = obj.nodeGroups;
  json.namespace_quota = obj.namespaceQuota;
  json.resource_quota = {
    cpu_limit: obj.resourceQuota.cpuLimit,
    cpu_request: obj.resourceQuota.cpuRequest,
    memory_limit: obj.resourceQuota.memoryLimit,
    memory_request: obj.resourceQuota.memoryRequest,
  };
  json.argocd_project = obj.argocdProject && {
    repositories: obj.argocdProject.repositories,
    root_path: obj.argocdProject.rootPath,
    helm_repositories: obj.argocdProject.helmRepositories,
  };

  return json;
};

export const deserializeCluster = (json: any): Cluster => {
  return {
    id: json.id,
    name: json.name,
    stage: json.stage,
    tier: json.tier,
    nodeGroups: json.node_groups.map(
      (x: { name: string; owners: string[] | null }) => x.name,
    ),
  };
};
